export const baseURL = "https://teenpatti.betalive92.com/";
export const adminBaseURL = "https://admin.betalive92.com/";
export const key = "FOz*xPL)7NRPX;Rp=?{ICWU6VbgD.7(X";